import { contrastRatio, contrastGrade, bestTextOn } from "@/lib/colorContrast";
import { CheckCircle, Warning, ArrowsLeftRight } from "@phosphor-icons/react";

/** Inline contrast indicator for two colors. */
export default function ContrastBadge({ fg, bg, label = "Contrast", onAutoFix }) {
  const ratio = contrastRatio(fg, bg);
  const grade = contrastGrade(ratio);
  if (ratio == null) return null;

  const styles = {
    aaa:       { bg: "bg-emerald-50",  text: "text-emerald-700", icon: CheckCircle, msg: `${ratio.toFixed(1)}:1 — AAA (excellent)` },
    aa:        { bg: "bg-emerald-50",  text: "text-emerald-700", icon: CheckCircle, msg: `${ratio.toFixed(1)}:1 — AA (good)` },
    "aa-large":{ bg: "bg-amber-50",    text: "text-amber-700",   icon: Warning,     msg: `${ratio.toFixed(1)}:1 — only OK for large text` },
    fail:      { bg: "bg-rose-50",     text: "text-rose-700",    icon: Warning,     msg: `${ratio.toFixed(1)}:1 — fails WCAG, hard to read` },
  };
  const s = styles[grade] || styles.fail;
  const Icon = s.icon;
  const suggested = bestTextOn(bg);
  const showFix = grade === "fail" || grade === "aa-large";

  return (
    <div className={`inline-flex items-center gap-2 px-2.5 py-1.5 rounded-sm text-[11px] ${s.bg} ${s.text}`} data-testid={`contrast-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <Icon size={12} weight="fill" />
      <span>{label}: {s.msg}</span>
      {showFix && onAutoFix && (
        <button
          type="button"
          onClick={() => onAutoFix(suggested)}
          className="ml-1 inline-flex items-center gap-1 underline hover:no-underline"
          title={`Switch text to ${suggested}`}
        >
          <ArrowsLeftRight size={10} /> use {suggested === "#FFFFFF" ? "white" : "black"}
        </button>
      )}
    </div>
  );
}
